import { FeatureFlag } from '../FeatureFlag';

/**
 * Rolls out refresh-on-rejection and the recoverable expired-session UX.
 */
export const managedSessionLifecycle = new FeatureFlag({
    key: 'managed-session-lifecycle',
    createdOn: '2026-07-24',
    defaultValue: false,
});
